export default __webpack_public_path__ + "static/media/41349f4ae77621aa818a599b16d3604a.e6745b54.png";